(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ophaya-feature-video-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ophaya-video-tabs')) {
    customElements.define(
      'ophaya-video-tabs',
      class OphayaVideoTabs extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;

          this.initialized = true;
          this.tabs = Array.from(this.querySelectorAll('[data-oft-tab]'));
          this.panels = Array.from(this.querySelectorAll('[data-oft-panel]'));
          this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.onEditorSelect = this.handleEditorSelect.bind(this);

          this.tabs.forEach((tab, index) => {
            tab.addEventListener('click', () => this.selectTab(index, { animate: true }));
            tab.addEventListener('keydown', (event) => this.handleKeydown(event, index));
          });

          this.panels.forEach((panel) => {
            const video = panel.querySelector('video');
            const control = panel.querySelector('[data-oft-playback]');

            if (!video || !control) return;

            video.muted = true;
            video.loop = true;
            video.playsInline = true;
            video.removeAttribute('controls');
            control.addEventListener('click', () => this.togglePlayback(panel));
            video.addEventListener('play', () => this.updateControl(panel));
            video.addEventListener('pause', () => this.updateControl(panel));
            video.addEventListener('ended', () => this.updateControl(panel));
          });

          document.addEventListener('shopify:block:select', this.onEditorSelect);
          this.classList.add('is-ready');

          if (this.tabs.length > 0) {
            this.selectTab(0, { animate: false, restart: false });
          }
        }

        disconnectedCallback() {
          document.removeEventListener('shopify:block:select', this.onEditorSelect);
        }

        selectTab(index, options = {}) {
          const nextTab = this.tabs[index];
          const nextPanel = this.panels[index];
          if (!nextTab || !nextPanel) return;

          const applySelection = () => {
            this.tabs.forEach((tab, tabIndex) => {
              const active = tabIndex === index;
              tab.classList.toggle('is-active', active);
              tab.setAttribute('aria-selected', String(active));
              tab.tabIndex = active ? 0 : -1;
            });

            this.panels.forEach((panel, panelIndex) => {
              const active = panelIndex === index;
              const video = panel.querySelector('video');

              panel.classList.toggle('is-active', active);
              panel.hidden = !active;

              if (!video) return;

              if (!active) {
                video.pause();
                video.currentTime = 0;
                this.updateControl(panel);
                return;
              }

              if (options.restart) video.currentTime = 0;

              if (!this.reducedMotion) {
                const playPromise = video.play();
                if (playPromise) playPromise.catch(() => this.updateControl(panel));
              }

              this.updateControl(panel);
            });
          };

          if (
            options.animate &&
            !this.reducedMotion &&
            typeof document.startViewTransition === 'function'
          ) {
            document.startViewTransition(applySelection);
          } else {
            applySelection();
          }

          if (options.focus) {
            nextTab.focus();
            nextTab.scrollIntoView({ behavior: this.reducedMotion ? 'auto' : 'smooth', block: 'nearest', inline: 'center' });
          }
        }

        handleKeydown(event, index) {
          let nextIndex = index;

          if (event.key === 'ArrowRight') nextIndex = (index + 1) % this.tabs.length;
          if (event.key === 'ArrowLeft') nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = this.tabs.length - 1;
          if (nextIndex === index) return;

          event.preventDefault();
          this.selectTab(nextIndex, { animate: true, focus: true });
        }

        togglePlayback(panel) {
          const video = panel.querySelector('video');
          if (!video) return;

          if (video.paused) {
            const playPromise = video.play();
            if (playPromise) playPromise.catch(() => this.updateControl(panel));
          } else {
            video.pause();
          }

          this.updateControl(panel);
        }

        updateControl(panel) {
          const video = panel.querySelector('video');
          const control = panel.querySelector('[data-oft-playback]');
          if (!video || !control) return;

          const paused = video.paused;
          control.classList.toggle('is-paused', paused);
          control.setAttribute(
            'aria-label',
            paused ? this.dataset.playLabel : this.dataset.pauseLabel,
          );
        }

        handleEditorSelect(event) {
          const blockId = event.detail && event.detail.blockId;
          if (!blockId) return;

          const index = this.panels.findIndex((panel) => panel.dataset.blockId === blockId);
          if (index >= 0) this.selectTab(index, { animate: false, focus: false });
        }
      },
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-bar"] && !Shopify.designMode) return;
  try {
    
  let top_bar = document.querySelector('.section-top-bar')?.clientHeight || 0;
  const body = document.querySelector('body');
  body.style.setProperty('--height-topbar', `${top_bar}px`);

  } catch(e) { console.error(e); }
})();
})();
